const state = {
    address: '',
    privateKey: '',
    ethereumContract: ''
}

const getters = {
    getAddress(state: any) {
        return state.address;
    },
    getPrivateKey(state: any) {
        return state.privateKey;
    },
    getEthereumContract(state: any) {
        return state.ethereumContract;
    }
}

const actions = {
    // incActionCounter(store: any, payload: any){
    //     // Mutationsへ
    //     store.commit('incrementMutateCounter', payload)
    // },
    setAddress(store: any, address: string) {
        return new Promise((resolve) => {
            store.commit('setAddress', address);
            resolve(true);
        });
    },
    setPrivateKey(store: any, privateKey: string) {
        return new Promise((resolve) => {
            store.commit('setPrivateKey', privateKey);
            resolve(true);
        });
    },
    async setEthereumContract(store: any, contractAddress: string) {
        store.commit('setEthereumContract', contractAddress);
        return true;
    }
}

const mutations = {
    setAddress(state: any, address: string) {
        state.address = address;
    },
    setPrivateKey(state: any, privateKey: string) {
        state.privateKey = privateKey;
    },
    setEthereumContract(state: any, contractAddress: string) {
        state.ethereumContract = contractAddress;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
